import styled from "styled-components";

export const TextWrapperDiv = styled.div`
  --insidePadding: 25px;
  background-color: var(--white);
  padding: var(--insidePadding);
  margin-bottom: var(--outsidePadding);
  & h1,
  h2,
  h3,
  h4 {
    margin-top: 0;
  }
  & > div {
    width: 100%;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  & h2:first-child {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 24px;
    letter-spacing: 0.5px;
  }
  & h2:last-child,
  & p:last-child {
    margin-bottom: 0;
  }
  & a {
    color: var(--text);
    text-decoration: underline;
    &:hover {
      color: var(--highlight);
      text-decoration: underline;
    }
  }
  & sup {
    padding-right: 4px;
  }
  & figure {
    margin: 24px;
    & p {
      margin: 0;
    }
    & img {
      width: 100%;
      height: auto;
      margin-bottom: 24px;
    }
  }
  @media (max-width: 1023px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
